import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-hospitalization-simple-tab',
  templateUrl: './ui-hospitalization-simple-tab.component.html',
  styleUrls: ['./ui-hospitalization-simple-tab.component.scss']
})
export class UiHospitalizationSimpleTabComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  /* Modals for Hospital and Doctor -- OLD */
  modHospDetails:boolean = false;
  modDocDetails:boolean = false;

}
